import { useState } from 'react'

export const usePagination = () => {
  const [useTotalPages, setTotalPages] = useState(1)
  const [useCurrentPage, setCurrentPage] = useState(1)

  const onPageChange = (page: number) => {
    setCurrentPage(page)
  }

  const onTotalPagesChange = (total: number) => {
    setTotalPages(total)
  }

  return { useTotalPages, useCurrentPage, onPageChange, onTotalPagesChange }
}

export default usePagination
